import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import API from '@/apis/TPSAPI';
import { M_ICloseAccountRecord } from "@/models/M_ICloseAccount";
import { ElMessage } from 'element-plus';

export default /*#__PURE__*/_defineComponent({
  __name: 'CloseAccountDataMgmt',
  setup(__props) {

const dateRange = ref<string[]>([]);
const closeAccountRecords = ref<M_ICloseAccountRecord[]>([]);

const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const handleDateRangeChange = async (dates: string[] | null) => {
  if (!dates || dates.length !== 2) {
    closeAccountRecords.value = [];
    return;
  }

  const [startDate, endDate] = dates;

  try {
    const response = await API.getCloseAccounts(startDate, endDate);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    closeAccountRecords.value = response.data.content;

    ElMessage.success(`查詢成功，找到 ${closeAccountRecords.value.length} 筆關帳記錄`);

    console.log('關帳記錄:', closeAccountRecords.value);

  } catch (error) {
    closeAccountRecords.value = [];
    ElMessage.error((error as Error).message || '查詢關帳記錄失敗');
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: dateRange.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "開始日期",
              "end-placeholder": "結束日期",
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD",
              style: {"width":"100%"},
              onChange: handleDateRangeChange
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              name: "closeAccountTable",
              style: {"width":"100%"},
              height: "500",
              data: closeAccountRecords.value,
              "empty-text": "請選擇日期範圍查詢關帳記錄"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "關帳日期",
                  prop: "closeDate"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(formatDate(row.closeDate)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "昨日零用金結餘",
                  prop: "yesterdayPettyIncome"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "營業收入",
                  prop: "businessIncome"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "關帳結算金額",
                  prop: "closeAccountAmount"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "提存金額",
                  prop: "depositAmount"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "當日零用金結餘",
                  prop: "pettyIncome"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})